import { z } from 'zod';

const decimalString = z.string().regex(/^-?\d+(\.\d+)?$/, 'invalidDecimal');

export const SettlementResponseSchema = z.object({
  id: z.string().min(1),
  deal_id: z.string().min(1),
  cashflow_id: z.string().min(1),
  counterparty_id: z.string().min(1),
  payment_date: z.string(),
  amount: decimalString,
  currency: z.string(),
  direction: z.string(),
  status: z.string(),
  ssi_id: z.string().min(1).nullable().optional(),
  external_reference: z.string().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type SettlementResponse = z.infer<typeof SettlementResponseSchema>;

export const NettingSetResponseSchema = z.object({
  id: z.string().min(1),
  counterparty_id: z.string().min(1),
  currency: z.string(),
  payment_date: z.string(),
  gross_payable: decimalString,
  gross_receivable: decimalString,
  net_amount: decimalString,
  net_direction: z.string(),
  settlement_ids: z.array(z.string().min(1)),
  created_at: z.string(),
});

export type NettingSetResponse = z.infer<typeof NettingSetResponseSchema>;

export const NetSettlementsRequestSchema = z.object({
  settlement_ids: z.array(z.string().min(1)).min(1, 'required'),
});

export type NetSettlementsRequest = z.infer<typeof NetSettlementsRequestSchema>;

export const ExecuteNettingPayloadSchema = z.object({
  settlement_ids: z.array(z.string().min(1)).optional(),
  counterparty_id: z.string().min(1).optional(),
  currency: z.string().optional(),
  payment_date: z.string().optional(),
});

export type ExecuteNettingPayload = z.infer<typeof ExecuteNettingPayloadSchema>;

export const NettingSetsPayloadSchema = z.object({
  counterparty_id: z.string().min(1).optional(),
  currency: z.string().optional(),
  payment_date: z.string().optional(),
});

export type NettingSetsPayload = z.infer<typeof NettingSetsPayloadSchema>;
